import type { BoardModel } from "../domain/types";
import { BOARD_820_00165 } from "./boards.820-00165.seed";
import { BOARD_820_02016 } from "./boards.820-02016.seed";

// SEED = uniquement les cartes VITRINE (gratuites en démo), embarquées pour le
// 1er lancement hors-ligne : 1 Intel (Air 2014) + 1 Apple Silicon (Air M1).
// Le RESTE de la base de connaissances n'est PAS dans le build : il est livré
// par /v1/sync UNIQUEMENT aux postes licenciés (modèle freemium). Les postes
// démo reçoivent des "stubs" verrouillés (nom seulement) → catalogue visible,
// savoir protégé. ⚠️ Ne PAS ré-embarquer toutes les cartes ici (ça casserait
// le modèle payant en redonnant tout hors-ligne).

export const SEED_BOARDS: BoardModel[] = [
  BOARD_820_00165,
  BOARD_820_02016,
];
